// @view/panels/document/review/NewSectionModal.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { VisibilityPhase } from "@ps-bridge/models/ui/visibilityPhase";
import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import NewSectionModalVisibleView from "@view/document/review/NewSectionModalVisible.view";

type NewSectionModalPanelProps = {
  phase: VisibilityPhase;
} & Pick<
  DocumentReviewViewProps,
  | "closeModal"
  | "newSectionTitle"
  | "setNewSectionTitle"
  | "handleSubmitNewSection"
  | "sectionTitleErrorPhase"
  | "sectionTitleErrorMessage"
>;

const NewSectionModalPanel: React.FC<NewSectionModalPanelProps> = (props) => {
  const { phase, ...viewProps } = props;
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<VisibilityPhase, VisibilityPhase>;
  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: <NewSectionModalVisibleView {...viewProps} />,
  } as const satisfies Record<VisibilityPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(NewSectionModalPanel);
